// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de889ba0","239":"c25c7bfe","667":"5018e87e"}[chunkId] + ".chunk.js";
};